import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { QueryFilter } from 'lib/tables/DataFilter';
import { CreatePenOrderDto, CreatePenOrderResonseDto, PenOrderDto, PenOrderListItemDto } from 'models/pen/PenOrder';
import { PenOrderStatusDto } from 'models/pen/PenOrderStatus';

@autoinject
export class PenOrderService {
  constructor(private client: NetlogHttpClient) {}

  async getOrder(id: number) {
    return await this.client.get<PenOrderDto>({
      url: `api/pen-order/get-order/${id}`,
      model: PenOrderDto,
    });
  }

  async createPenOrder(data: CreatePenOrderDto) {
    return await this.client.post({
      data,
      url: 'api/pen-order/create-order',
      model: CreatePenOrderResonseDto,
    });
  }

  async getOrders(query: QueryFilter) {
    return await this.client.get<PenOrderListItemDto[]>({
      url: `api/pen-order/list${query.asQueryString}`,
      model: PenOrderListItemDto,
    });
  }

  async createPens(penOfferId: number) {
    return await this.client.post({
      url: `api/pen-order/create-pens/${penOfferId}`,
    });
  }

  async updateOrderStatus(id: number, data: PenOrderStatusDto) {
    return await this.client.patch({
      data,
      url: `api/pen-order/${id}/status`,
    });
  }
}
